"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = buildRoarInferenceTimeline;
require("regenerator-runtime/runtime");
// setup
const helpers_1 = require("../shared/helpers");
const instructions_1 = require("./trials/instructions");
const taskSetup_1 = require("../taskSetup");
// trials
const trials_1 = require("../shared/trials");
const afcInference_1 = require("./trials/afcInference");
const config_1 = require("./helpers/config");
const repeatInstructions_1 = require("../shared/trials/repeatInstructions");
const taskStore_1 = require("../../taskStore");
let roarInferenceValidityEvaluator = null;
async function buildRoarInferenceTimeline(config, mediaAssets) {
    const preloadTrials = (0, helpers_1.createPreloadTrials)(mediaAssets).default;
    (0, taskStore_1.taskStore)('currentCatBlock', 0);
    (0, helpers_1.initTrialSaving)(config);
    const initialTimeline = (0, helpers_1.initTimeline)(config, trials_1.enterFullscreen);
    const timeline = [preloadTrials, initialTimeline, ...instructions_1.instructions];
    const corpus = (0, taskStore_1.taskStore)().corpora.stimulus;
    const translations = (0, taskStore_1.taskStore)().translations;
    const validationErrorMap = {};
    const layoutConfigMap = {};
    let i = 0;
    for (const c of corpus) {
        const { itemConfig, errorMessages } = (0, config_1.getLayoutConfig)(c, translations, mediaAssets, i);
        layoutConfigMap[c.itemId] = itemConfig;
        layoutConfigMap[c.itemId].story = (0, helpers_1.convertItemToString)(c.item);
        layoutConfigMap[c.itemId].storyId = c.itemId;
        if (errorMessages.length) {
            validationErrorMap[c.itemId] = errorMessages.join('; ');
        }
        i += 1;
    }
    const trialConfig = {
        responseAllowed: true,
        promptAboveButtons: true,
        task: config.task,
        layoutConfigMap,
    };
    const stimulusBlock = (config) => ({
        timeline: [(0, afcInference_1.afcStimulusInference)(config)],
    });
    if ((0, helpers_1.shouldUseClowder)()) {
        await (0, taskSetup_1.initializeClowder)(config);
        (0, taskSetup_1.setNextStimulus)({ ignorePreviousItem: true });
        roarInferenceValidityEvaluator = (0, helpers_1.createValidityEvaluator)(config);
        const testBlock = {
            timeline: [(0, afcInference_1.afcStimulusInference)({ ...trialConfig, validityEvaluator: roarInferenceValidityEvaluator })],
            loop_function: () => {
                const additionalItemsToRemove = taskSetup_1.clowder.remainingItems.filter((item) => { var _a; return item.itemId === ((_a = (0, taskStore_1.taskStore)().nextStimulus) === null || _a === void 0 ? void 0 : _a.itemId); });
                (0, taskSetup_1.setNextStimulus)({ additionalItemsToRemove });
                return (0, taskStore_1.taskStore)().nextStimulus != undefined;
            },
        };
        timeline.push(testBlock);
    }
    else {
        const repeatInstructions = {
            timeline: [repeatInstructions_1.repeatInstructionsMessage],
            conditional_function: () => {
                return (0, taskStore_1.taskStore)().numIncorrect >= 2;
            },
        };
        const instructionsRepeated = {
            timeline: instructions_1.instructions,
            conditional_function: () => {
                return (0, taskStore_1.taskStore)().numIncorrect >= 2;
            },
        };
        const inferenceNumStories = (0, taskStore_1.taskStore)().inferenceNumStories;
        const stimulusBlocks = (0, taskStore_1.taskStore)().stimulusBlocks;
        const numOfTrials = inferenceNumStories == null || stimulusBlocks == null
            ? (0, taskStore_1.taskStore)().totalTrials
            : inferenceNumStories * stimulusBlocks;
        //const numOfTrials = inferenceNumStories * stimulusBlocks ?? taskStore().totalTrials;
        for (let i = 0; i < numOfTrials; i += 1) {
            if (i === 4) {
                timeline.push(repeatInstructions);
                timeline.push(instructionsRepeated);
            }
            timeline.push({
                ...trials_1.setupStimulus,
                stimulus: ``, // Custom stimulus
            });
            timeline.push(stimulusBlock(trialConfig));
            // timeline.push(ifRealTrialResponse);
        }
    }
    (0, taskSetup_1.initializeCat)();
    timeline.push((0, trials_1.taskFinished)());
    timeline.push(trials_1.exitFullscreen);
    return { jsPsych: taskSetup_1.jsPsych, timeline };
}
